import ActionsForm from '@/shared/mixins/actionsForm'
import AprReportTable from './components/aprReportTable/aprReportTable.vue'
import AprReportFiltro from './components/aprReportTable/components/aprReportFiltro/aprReportFiltro.vue'
import AprReportPainel from './components/aprReportTable/components/aprPainelReport/aprPainelReport.vue'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'

export default {
  name: 'aprReport',
  components: {AprReportTable, AprReportFiltro, HeadDetailsGama, AprReportPainel},
  mixins: [ActionsForm],
  data () {
    return {

    }
  },
  methods: {
    search (data) {
      this.$refs.tableRelatorioAPR.formSearch = data
      this.$refs.tableRelatorioAPR.onLoad()
      this.$refs.painelAPR.formSearch = data
      this.$refs.painelAPR.onLoad()
    },
    quantitativos (data) {
      this.$refs.tableRelatorioAPR.quantitativosPDF = data
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/apr/aprReport/aprReport.js